import type { UseQueryResult } from '@tanstack/react-query/src/types';
import { QueryKey } from '../../utils/api';
import { isServer } from '../../utils/utils';
import { useBffGet } from '../bff';
import type { AdminProduct } from './model/AdminProduct';
import type { PageResponse } from './model/PageResponse';

export const useCookingClassesByStore = (
    storeId: string | undefined,
): UseQueryResult<PageResponse<AdminProduct[]>> =>
    useBffGet<PageResponse<AdminProduct[]>>(
        `/stores/${storeId}/cooking-classes`,
        [],
        [QueryKey.GET_COOKING_CLASSES_BY_STORE, storeId ?? ''],
        {
            enabled: !!storeId && !isServer,
            staleTime: Infinity,
        },
    );
